/**************************************************************************
 * Created on Feb 24 2026
 *
 *  # Honeywell Code Usage Policy
 *
 * **Honeywell Source Code Usage Policy Classification:** Highly Confidential
 *
 ********************************************************************************/

import React, { useEffect, useState } from 'react';

interface TimerProps {
  seconds?: number;
}

export default function Timer({ seconds = 60 }: TimerProps) {
  const [timer, setTimer] = useState(seconds);

  useEffect(() => {
    // Reset timer when seconds prop changes (modal reopens)
    setTimer(seconds);

    const interval = setInterval(() => {
      setTimer((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          window.dispatchEvent(new Event('session-expired'));
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [seconds]);

  const minutes = Math.floor(timer / 60);
  const secs = timer % 60;

  return (
    <span style={{ fontWeight: 'bold', color: '#d32f2f' }}>
      {minutes}:{secs.toString().padStart(2, '0')}
    </span>
  );
}
